/**
 * Create blob
 * @param {ArrayBuffer} data
 * @param {String} type
 */
function blobFactory(data: ArrayBuffer, type?: string) {
  if (!(data instanceof ArrayBuffer)) {
    throw new Error('data must be ArrayBuffer');
  }
  if (type) {
    return new Blob([data], { type });
  }
  return new Blob([data]);
}

export default blobFactory;
